import moment from "moment";
import React, { useState, useEffect, useCallback } from "react";

const MonitorContext = React.createContext([{}, () => {}]);

window.monitor_ws = null;

const MonitorProvider = (props) => {
  const [ws, setWS] = useState(null);
  const [wsStatus, setWSStatus] = useState(-1);
  const [game, setGame] = useState();
  const [page, setPage] = useState();
  const sendData = (data) => {
    try {
      if (window.monitor_ws) {
        data.user = {
          id: window.id,
        };

        data.group = localStorage.getItem("user-id");
        data.app = "engine";

        data.engine =
          window.engines?.find((e) => e.key === window.engine_key)?.name ||
          window.engine_key;
        window.monitor_ws.send(
          JSON.stringify({
            ...data,
            version: window.version,
            time: moment(),
            project_name: window.project_name,
            project_last_updated: window.project_last_updated,
            query_params: window.query_params?.toString(),
            type: window.preview ? "preview" : "live",
          })
        );
      }
    } catch (err) {}
  };

  useEffect(() => {
    connect();
  }, []);

  function connect() {
    if (window.monitor_server) {
      console.log("Hyper monitor connecting to server");

      window.monitor_ws = new WebSocket(window.monitor_server);
      setWS(window.monitor_ws);
    }
  }

  useEffect(() => {
    if (window.monitor_ws) {
      let timeout;
      window.monitor_ws.onopen = () => {
        setWSStatus(1);
        console.log("Hyper monitor on open");
        keep_alive();
      };
      window.monitor_ws.onmessage = (data) => {
        console.log("Hyper monitor on message");
      };
      window.monitor_ws.onerror = (err) => {
        console.log("Hyper monitor on error");
        ws.close();
      };
      window.monitor_ws.onclose = (data) => {
        setWSStatus(0);
        console.log("Hyper monitor on close");
        clearTimeout(timeout);
        clearInterval(window.monitor_keep_alive);
        timeout = setTimeout(() => {
          connect();
        }, 1000);
      };
    }
  }, [ws]);

  const keep_alive = useCallback(() => {
    try {
      if (window.monitor_ws) {
        window.monitor_ws.send(
          JSON.stringify({
            app: "engine",
            monitor_keep_alive: Date.now(),
            engine:
              window.engines?.find((e) => e.key === window.engine_key)?.name ||
              window.engine_key,
            time: moment(),
            project_name: window.project_name,
            project_last_updated: window.project_last_updated,
            query_params: window.query_params?.toString(),
            type: window.preview ? "preview" : "live",
          })
        );
      }
    } catch (err) {
      console.log(err);
    }
  }, [game, page]);

  useEffect(() => {
    clearInterval(window.monitor_keep_alive);
    window.monitor_keep_alive = setInterval(() => {
      keep_alive();
    }, 20000);
    keep_alive();
  }, [keep_alive]);

  return (
    <MonitorContext.Provider
      value={{
        sendData,
        setGame,
        setPage,
      }}
    >
      {props.children}
    </MonitorContext.Provider>
  );
};

export { MonitorContext, MonitorProvider };
